export default __webpack_public_path__ + "media/maps/print-c90dca4d.svg";